import { render, staticRenderFns } from "./ClientAssessment.vue?vue&type=template&id=22ae0d3e&scoped=true"
import script from "./ClientAssessment.vue?vue&type=script&lang=js"
export * from "./ClientAssessment.vue?vue&type=script&lang=js"
import style0 from "./ClientAssessment.vue?vue&type=style&index=0&id=22ae0d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae0d3e",
  null
  
)

export default component.exports